import React from 'react';
import PropTypes from 'prop-types';
import { OrderView } from '../../../orders/order';
import { formatDate } from '@ami/react/core';
import { GoogleMapsLink } from '@ami/react/core';
import { Link } from 'react-router-dom';
import { appConfig } from '@ami/react/core';
import { isAmiUserAuthorizedToViewOrderGroups } from '../../../authorization/amiPermissions';

export default class OrderInformationComponent extends React.PureComponent {
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
  };

  render() {
    const { order } = this.props;
    return (
      <div className="col">
        <div className="card mb-4 box-shadow order-info h-100">
          <div className="card-body">
            <h6 className="card-title text-center">Order Information</h6>
            <div className="row">
              <label className="col-sm-3">Created</label>
              <div className="col-sm-9">{formatDate(order.orderDate)}</div>
            </div>
            <div className="row">
              <label className="col-sm-3">Contact</label>
              <div className="col-sm-9">
                {order.dealerInformation.dealerUserName}
              </div>
            </div>
            <div className="row">
              <label className="col-sm-3">Industry</label>
              <div className="col-sm-9">
                {order.industryName || 'Not Specified'}
              </div>
            </div>
            <div className="row">
              <label className="col-sm-3">Branch</label>
              <div className="col-sm-9">
                <div>{order.dealerInformation.dealerBranchName}</div>
                <div>{order.dealerInformation.dealerBranchAddress}</div>
              </div>
            </div>
            <div className="row">
              <label className="col-sm-3">Sales Person</label>
              <div className="col-sm-9">{order.salesPersonName}</div>
            </div>
            <div className="row">
              <label className="col-sm-3">TM</label>
              <div className="col-sm-9">{order.territoryManagerName}</div>
            </div>
            <div className="row">
              <label className="col-sm-3">Notes</label>
              <div className="col-sm-9 text-break-line">{order.notes || 'N/A'}</div>
            </div>
            {appConfig.isManagementApp && (
              <div className="row">
                <label className="col-sm-3">Private notes</label>
                <div className="col-sm-9 text-break-line">{order.privateNotes || 'N/A'}</div>
              </div>
            )}
            <div className="row">
              <label className="col-sm-3">Billing Instructions</label>
              <div className="col-sm-9 text-break-line">{order.billingInstructions || 'N/A'}</div>
            </div>
            {order.quoteNumber && (
              <div className="row">
                <label className="col-sm-3">Quote</label>
                <div className="col-sm-9">
                  <Link to={`/quotes/view/${order.quoteId}`}>
                    {order.quoteNumber}
                  </Link>
                </div>
              </div>
            )}
            {appConfig.isManagementApp && (
              <div className="row">
                <label className="col-sm-3">Order Group</label>
                <div className="col-sm-9 text-break-line">
                  {isAmiUserAuthorizedToViewOrderGroups() ? (
                    order.orderGroupName ? (
                      <Link
                        target="_blank"
                        to={`/order-groups/view/${order.orderGroupId}`}
                      >
                        {order.orderGroupName}
                      </Link>
                    ) : (
                      'N/A'
                    )
                  ) : (
                    order.orderGroupName || 'N/A'
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
